<template>
  <!-- 文明数据 -->
  <section id="list" class="list">
    <div class="l-center">
      <h2 class="title"></h2>
      <div ref="swiper" class="swiper">
        <div class="swiper-wrapper" @click.capture="preview('open')">
          <div class="swiper-slide" v-for="(src, idx) in imgList" :key="idx">
            <img :src="src" alt="" />
          </div>
        </div>
        <div ref="prev" class="swiper-button-prev"></div>
        <div ref="next" class="swiper-button-next"></div>
        <div ref="pagination" class="swiper-pagination"></div>
      </div>
    </div>
    <div class="modal"></div>
    <DlgPerview :visible="visible" :src="src" @close="preview('close')" />
  </section>
</template>

<script>
import cfgData from "scripts/constants/configData";
import DlgPerview from "components/dialog/preview.vue";

let mySwiper = null;
export default {
  name: "Data",
  components: {
    DlgPerview,
  },
  data() {
    return {
      visible: false,
      src: null,
      imgList: [
        require("images/list/1.png"),
        require("images/list/2.png"),
        require("images/list/3.png"),
        require("images/list/4.png"),
        require("images/list/5.png"),
        require("images/list/6.png"),
      ],
    };
  },
  created() {},
  mounted() {
    mySwiper = new Swiper(this.$refs.swiper, {
      // spaceBetween: 10,
      autoplay: {
        delay: cfgData.swiperPlayDelay, // 10秒切换一次
      },
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      effect: "creative",
      creativeEffect: {
        limitProgress: 1,
        prev: {
          // shadow: true,
          origin: "center center",
          translate: ["-24%", 0, 0],
          // rotate: [0, 100, 0],
          scale: 0.8,
        },
        next: {
          origin: "center center",
          translate: ["24%", 0, 0],
          // rotate: [0, -100, 0],
          scale: 0.8,
        },
      },
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
      pagination: {
        el: this.$refs.pagination,
      },
      on: {
        slideChange: (swiper) => {
          this.src = this.imgList[swiper.realIndex];
        },
      },
    });
  },
  computed: {},
  methods: {
    preview(action) {
      if (action == "open") {
        mySwiper.autoplay.stop();
        this.visible = true;
      } else if (action == "close") {
        mySwiper.autoplay.start();
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.swiper {
  width: 260%;
  margin-left: -80%;
}
</style>

<style lang="less">
.list {
  position: relative;
  height: 700px;

  .l-center {
    position: relative;
    overflow: hidden;
  }

  .title {
    margin: 30px 0 53px;
    height: 68px;
    background: url(~images/title/data.png) no-repeat 0 center;
    background-size: 100% auto;
  }

  .swiper {
    height: 500px;

    .swiper-slide {
      @width: 777px;
      @height: 416px;

      position: relative;
      text-align: center;
      height: @height;
      // background-color: aliceblue;

      img {
        height: @height;
      }

      &::before {
        position: absolute;
        // top: 50%;
        left: 50%;
        margin-top: 8px;
        margin-left: (@width / 2) * -1 + 10px;
        content: "";
        width: @width - 18px;
        height: @height - 18px;
        background-color: rgba(0, 0, 0, 0.7);
        // transform: skewX(-6.6deg);
        border-radius: 38px 4px;
      }

      &::before {
        z-index: 1;
      }

      &-active {
        &::before {
          content: none;
        }
      }
    }
  }

  .swiper-button-prev {
    left: calc(30% + 120px);
    width: 42px;
    height: 66px;
    background: url(~images/join/btn_prev.png) no-repeat 0 center;
    background-size: 100% 100%;
  }

  .swiper-button-next {
    right: calc(30% + 120px);
    width: 42px;
    height: 66px;
    background: url(~images/join/btn_next.png) no-repeat 0 center;
    background-size: 100% 100%;
  }

  .swiper-button-prev,
  .swiper-button-next {
    margin-top: -72px;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    content: none;
  }

  .swiper-pagination-bullets {
    bottom: 25px;
    @bullet-size: 8px;
    @border-width: 1px;

    .swiper-pagination-bullet {
      width: @bullet-size;
      height: @bullet-size;
      margin: 0 2px;
      background-color: transparent;
      border: @border-width solid #493f31;
      opacity: 1;

      &-active {
        margin: 0 4px;
        width: 98px;
        border-radius: calc(@bullet-size / 2);
        background-color: #f8b22c;
        border: (@border-width / 2) solid #493f31;
      }
    }
  }

  .modal {
    position: absolute;
    top: -184px;
    // top: 265px;
    right: -20px;
    width: 532px;
    height: 1144px;
    background: url(~images/list/modal.png) no-repeat 0 0;
    background-size: 100% 100%;
    z-index: 1;
  }
}
</style>
